export const getFormatCurrencyOptions = (locale, currency) => {
  return {
    style: 'currency',
    locale: locale,
    currency: currency,
    minimumFractionDigits: locale === 'cs' ? 0 : 2,
    maximumFractionDigits: locale === 'cs' ? 0 : 2,
  }
}
